"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxContainer = void 0;
var tslib_1 = require("tslib");
var ui_flex_1 = require("@hopin-team/ui-flex");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.CheckboxContainer = (0, styled_components_1.default)(ui_flex_1.Flex)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1;
//# sourceMappingURL=checkbox-container.js.map